import React, { useState } from 'react'
import { BsArrowLeftRight } from 'react-icons/bs'
import { FaFolderClosed } from 'react-icons/fa6'
import { IoDocumentText } from 'react-icons/io5'
import { MdDelete, MdOutlineOndemandVideo } from 'react-icons/md'
import { GoPersonAdd } from 'react-icons/go'
import { FiEdit } from 'react-icons/fi'
import { FaImage } from 'react-icons/fa'
import RenameModal from './Modals/renameModal'
import AssignEmployeesModal from './Modals/assignEmployeesModal'
import MoveModal from './Modals/moveModal'

export const FolderView = ({
	folders = [],
	documents = [],
	onOpen,
	formatDate,
	onDelete,
	onMove,
	employeesList = [],
	modalFolders,
	onRename,
	loading,
	onAssign,
	allowClick,
	onDeleteDocument,
	onMoveDocument,
	currentFolder,
	employeeView,
}) => {
	const [moveModalId, setMoveModalId] = useState(null)
	const [deleteModalId, setDeleteModalId] = useState(null)
	const [deleteStep, setDeleteStep] = useState(1)
	const [selectedFolder, setSelectedFolder] = useState(null)
	const [moveDocModalId, setMoveDocModalId] = useState(null)
	const [assignModalId, setAssignModalId] = useState(null)
	const [renameModalId, setRenameModalId] = useState(null)
	const [renameCurrentName, setRenameCurrentName] = useState('')
	const [deleteDocModalId, setDeleteDocModalId] = useState(null)

	const getIconByExtension = fileName => {
		const ext = fileName.toLowerCase().split('.').pop()
		const docExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']
		const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm']
		const imgExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico']
		if (docExts.includes(ext)) return <IoDocumentText className='tw-text-blue-500' />
		if (videoExts.includes(ext)) return <MdOutlineOndemandVideo className='tw-text-red-500' />
		if (imgExts.includes(ext)) return <FaImage className='tw-text-green-500' />
		return null
	}

	const docToDelete = documents.find(d => d.id === deleteDocModalId)

	const isParticularRoot = currentFolder && currentFolder.private && currentFolder.parentId === null

	if (isParticularRoot && folders.length && folders[0].isEmployeeVirtual) {
		return (
			<div className='tw-mt-6'>
				<div className='tw-grid tw-grid-cols-1 border-bottom tw-text-gray-600 tw-text-base tw-font-medium tw-px-4 tw-py-2'>
					<span>Colaborador</span>
				</div>
				{employeesList.map(emp => (
					<div
						key={emp.id}
						className='tw-grid tw-grid-cols-1 border-bottom tw-items-center tw-px-4 tw-py-4 hover:tw-bg-gray-50 tw-cursor-pointer tw-text-base'
						onClick={() => (allowClick ? onOpen(emp.id) : null)}
					>
						<div className='tw-flex tw-items-center tw-gap-6'>
							<FaFolderClosed className='tw-text-alert-500' />
							{emp.name}
						</div>
					</div>
				))}
				{employeesList.length === 0 && <div className='tw-text-center tw-text-base tw-text-gray-500 tw-p-4'>Nenhum colaborador encontrado.</div>}
			</div>
		)
	}

	return (
		<div className='tw-mt-6'>
			<div className='tw-grid tw-grid-cols-3 border-bottom tw-text-gray-600 tw-text-base tw-font-medium tw-px-4 tw-py-2'>
				<span>Nombre</span>
				<span>Última modificación</span>
				<span className='tw-text-right'></span>
			</div>

			{folders.map(folder => (
				<div
					key={folder.id}
					onClick={() => (allowClick ? onOpen(folder.id) : null)}
					className='tw-grid tw-grid-cols-3 border-bottom tw-items-center tw-px-4 tw-py-4 hover:tw-bg-gray-50 tw-cursor-pointer tw-text-base'
				>
					<div className='tw-flex tw-items-center tw-gap-6'>
						<FaFolderClosed className='tw-text-alert-500' />
						{folder.name}
					</div>
					<div>{formatDate(folder.updatedAt || new Date())}</div>
					<div className='tw-flex tw-items-center tw-justify-end tw-gap-1' onClick={e => e.stopPropagation()}>
						{!employeeView && folder.parentId !== null && folder.private === false && (
							<>
								<div className='tw-p-1 tw-rounded hover:tw-bg-gray-200' onClick={() => setAssignModalId(folder.id)} title='Relacionar colaboradores'>
									<GoPersonAdd className='tw-text-black' />
								</div>
								<div
									className='tw-p-1 tw-rounded hover:tw-bg-gray-200'
									onClick={() => {
										setRenameModalId(folder.id)
										setRenameCurrentName(folder.name)
									}}
									title='Renomear'
								>
									<FiEdit className='tw-text-black' />
								</div>
								<div
									className='tw-p-1 tw-rounded hover:tw-bg-gray-200'
									onClick={e => {
										e.stopPropagation()
										setMoveModalId(folder.id)
									}}
									title='Mover'
								>
									<BsArrowLeftRight className='tw-text-black' />
								</div>
								<div
									className='tw-p-1 tw-rounded hover:tw-bg-gray-200'
									onClick={() => {
										setDeleteModalId(folder.id)
										setDeleteStep(1)
									}}
									title='Excluir'
								>
									<MdDelete className='tw-text-black' />
								</div>
							</>
						)}
					</div>

					{deleteModalId === folder.id && (
						<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
							<div className='tw-bg-white tw-p-6 tw-rounded tw-shadow-lg tw-min-w-[350px]' onClick={e => e.stopPropagation()}>
								{deleteStep === 1 ? (
									<>
										<div className='tw-mb-4'>
											Usted está a punto de eliminar la carpeta <b>{folder.name}</b> junto con todo su contenido.
										</div>
										<div className='tw-mb-4'>¿Confirma que desea continuar con esta acción?</div>
										<div className='tw-flex tw-justify-end tw-gap-2'>
											<div
												className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
												onClick={e => {
													e.stopPropagation()
													setDeleteModalId(null)
												}}
											>
												Cancelar
											</div>
											<div
												className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg'
												onClick={e => {
													e.stopPropagation()
													setDeleteStep(2)
												}}
											>
												Confirmar
											</div>
										</div>
									</>
								) : (
									<>
										<div className='tw-mb-4'>
											Esta acción es <b>irreversible</b>
										</div>
										<div className='tw-mb-4'>¿Está completamente seguro de que desea proceder?</div>
										<div className='tw-flex tw-justify-end tw-gap-2'>
											<div
												className='border  tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
												onClick={e => {
													e.stopPropagation()
													setDeleteModalId(null)
												}}
											>
												Cancelar
											</div>
											<div
												className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg'
												onClick={e => {
													e.stopPropagation()
													setDeleteModalId(null)
													setDeleteStep(1)
													onDelete(folder.id)
												}}
											>
												Eliminar
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					)}
				</div>
			))}

			{documents.map(doc => (
				<div key={doc.id} className='tw-grid tw-grid-cols-3 tw-items-center tw-px-4 tw-py-4 hover:tw-bg-gray-50 tw-text-base'>
					<div className='tw-flex tw-items-center tw-gap-6'>
						{getIconByExtension(doc.name)}
						<a
							href={doc.url}
							target='_blank'
							rel='noopener noreferrer'
							className='tw-text-indigo-600 hover:tw-underline'
							onClick={e => e.stopPropagation()}
							download
						>
							{doc.name}
						</a>
					</div>
					<div>{formatDate(doc.updatedAt || new Date())}</div>
					<div className='tw-flex tw-items-center tw-justify-end tw-gap-1' onClick={e => e.stopPropagation()}>
						{employeeView ? (
							doc.owner === 'employee' && (
								<>
									{/* <div
										className='tw-p-1 tw-rounded hover:tw-bg-gray-200'
										onClick={() => {
											setMoveDocModalId(doc.id)
											setMoveModalId(null)
										}}
										title='Mover'
									>
										<BsArrowLeftRight className='tw-text-black' />
									</div> */}
									<div
										className='tw-p-1 tw-rounded hover:tw-bg-gray-200 tw-cursor-pointer'
										onClick={() => setDeleteDocModalId(doc.id)}
										title='Excluir'
									>
										<MdDelete className='tw-text-black' />
									</div>
								</>
							)
						) : (
							<>
								<div
									className='tw-p-1 tw-rounded hover:tw-bg-gray-200 tw-cursor-pointer'
									onClick={() => {
										setMoveDocModalId(doc.id)
										setMoveModalId(null)
									}}
									title='Mover'
								>
									<BsArrowLeftRight className='tw-text-black' />
								</div>
								<div className='tw-p-1 tw-rounded hover:tw-bg-gray-200 tw-cursor-pointer' onClick={() => setDeleteDocModalId(doc.id)} title='Excluir'>
									<MdDelete className='tw-text-black' />
								</div>
							</>
						)}
					</div>
				</div>
			))}

			{folders.length === 0 && documents.length === 0 && (
				<div className='tw-text-center tw-text-base tw-text-gray-500 tw-p-4'>No se encontró ningún elemento.</div>
			)}

			<MoveModal
				isOpen={!!moveModalId}
				onClose={() => {
					setMoveModalId(null)
					setSelectedFolder(null)
				}}
				folders={modalFolders}
				onMove={newParentId => {
					onMove(moveModalId, newParentId)
					setMoveModalId(null)
					setSelectedFolder(null)
				}}
				loading={loading}
				currentFolderId={moveModalId}
			/>

			<MoveModal
				isOpen={!!moveDocModalId}
				onClose={() => setMoveDocModalId(null)}
				folders={modalFolders}
				onMove={newParentId => {
					onMoveDocument && onMoveDocument(moveDocModalId, newParentId)
					setMoveDocModalId(null)
				}}
				loading={loading}
				currentFolderId={currentFolder?.id}
				movingDocument={true}
			/>

			{deleteDocModalId && (
				<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
					<div className='tw-bg-white tw-p-6 tw-rounded tw-shadow-lg tw-min-w-[350px]'>
						<div className='tw-mb-4'>
							Está a punto de eliminar el documento <b>{docToDelete?.name}</b>. ¿Desea continuar?
						</div>
						<div className='tw-flex tw-justify-end tw-gap-2'>
							<div
								className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
								onClick={() => setDeleteDocModalId(null)}
							>
								Cancelar
							</div>
							<div
								className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg'
								onClick={() => {
									onDeleteDocument(deleteDocModalId)
									setDeleteDocModalId(null)
								}}
							>
								Excluir
							</div>
						</div>
					</div>
				</div>
			)}

			{assignModalId && folders.find(f => f.id === assignModalId)?.private === false && (
				<AssignEmployeesModal
					isOpen={!!assignModalId}
					onClose={() => setAssignModalId(null)}
					employeesList={employeesList}
					employeesId={assignModalId ? (folders.find(f => f.id === assignModalId)?.employees || []).map(e => e.id) : []}
					folderId={assignModalId}
					onAssign={selectedEmployees => {
						onAssign(selectedEmployees, assignModalId)
						setAssignModalId(null)
					}}
					loading={loading}
				/>
			)}

			<RenameModal
				isOpen={!!renameModalId}
				onClose={() => setRenameModalId(null)}
				currentName={renameCurrentName}
				onRename={newName => {
					onRename(renameModalId, newName)
					setRenameModalId(null)
				}}
				loading={loading}
			/>
		</div>
	)
}
